import { request } from '@umijs/max';

// 获取操作员分页列表
export async function getShopOperatorPage(params: API.PageParams) {
  return request('/api/admin/shopOperator/page', {
    method: 'POST',
    data: {
      ...params,
      with: ['shop'],
    },
  });
}

// 获取操作员详情
export async function getShopOperatorInfo(params: { id: number, with: any }) {
  return request('/api/admin/shopOperator/info', {
    method: 'POST',
    data: params,
  });
}
